<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <router-link :to="{path: '/'}"><img src="/logo_ecoverse.png" height="70px" alt="ecoverse"/></router-link>
      <span class="navbar-brand">{{routeName}}</span>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>
          <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Settings
              </p>
            </a>
          </li> -->
          <li class="nav-item">
            <router-link :to="{path: '/'}" class="nav-link" title="Home">
              <i class="icomoon-home" style="padding:7px;border: 1px solid #222222;border-radius:50%; background-color: #000000; color:#ffffff;"></i>
              <!-- <p>
                Home
              </p> -->
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{path: '/profile'}" class="nav-link" title="My Account">
              <i class="icomoon-user" style="padding:7px;border: 1px solid #222222;border-radius:50%; background-color: #000000; color:#ffffff;"></i>
              <!-- <p>
                {{ ($root.getLoggedUser()) ? $root.getLoggedUser().email : '' }}
              </p> -->
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{path: '/ghg'}" class="nav-link" title="GHG Calculator">
              <i class="icomoon-calculator" style="padding:7px;border: 1px solid #222222;border-radius:50%; background-color: #000000; color:#ffffff;"></i>
              <!-- <p>
                {{ ($root.getLoggedUser()) ? $root.getLoggedUser().email : '' }}
              </p> -->
            </router-link>
          </li>
          <li class="nav-item">
            <a v-if="$root.canUserDo(['logout'])" href="#!" class="nav-link" @click="$root.logout();" title="log out">
              <i class="icomoon-exit" style="padding:7px;border: 1px solid #222222;border-radius:50%; background-color: #000000; color:#ffffff;"></i>
              <!-- <p>Log out</p> -->
            </a>
            <span v-else style="cursor: not-allowed;" class="nav-item text-muted" title="log out">
              <i class="icomoon-exit" style="padding:5px;border: 1px solid #222222;border-radius:50%;"></i>
              <!-- <p>Log out</p>   -->
            </span>
          </li>
        </ul>
      </div>
    </div></nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      if (name === 'case') {
        return null;
      }
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
<style>
</style>
